export default "__VITE_ASSET__BDbG9T$M__"